import React from 'react';
import { FaBook, FaCashRegister, FaClipboardList, FaEnvelopeOpenText, FaUsers } from 'react-icons/fa';
import { GoGraph } from 'react-icons/go';
import { MdOutlineSecurity } from 'react-icons/md';
import { RiAdminFill, RiSpyFill } from 'react-icons/ri';

import { CashFlowDocumentKinds } from 'bus/cash/types/cashFlow';

export const navigation = (items: CashFlowDocumentKinds[]) => [
  {
    text: 'Заявки',
    path: '/task',
    icon: <FaEnvelopeOpenText />,
    folder: true,
    claims: ['CanLookTaskSection'],
    items: [
      {
        text: 'Заявки',
        path: '/task',
        claims: ['CanLookTaskSection'],
      },
      {
        text: 'Архивные',
        path: '/task-arch',
        claims: ['CanLookTaskSection'],
      },
      {
        text: 'Оффлайн заявки',
        path: '/offline-requests',
        claims: ['CanSeeOfflineRequestWorks'],
      },
      {
        text: 'Смены',
        path: '/shift',
        claims: ['all'],
      },
    ],
  },
  {
    text: 'Сотрудники',
    icon: <FaUsers />,
    folder: true,
    claims: ['CanLookEmployeeSection'],
    items: [
      {
        text: 'Сотрудники',
        path: '/employee',
        claims: ['CanLookEmployeeSection'],
      },
      {
        text: 'Должности',
        path: '/post',
        claims: ['CanLookBookSection'],
      },
    ],
  },
  {
    text: 'Контрагенты',
    icon: <RiSpyFill />,
    folder: true,
    claims: ['CanLookContragentSection'],
    items: [
      {
        text: 'Юр. лица',
        path: '/contractorLegal',
        claims: ['all'],
      },
      {
        text: 'Физ. лица',
        path: '/contractorIndividual',
        claims: ['all'],
      },
    ],
  },
  {
    text: 'Номенклатура',
    icon: <FaClipboardList />,
    folder: true,
    claims: ['CanLookNomenclatureSection'],
    items: [
      {
        text: 'Материалы',
        path: '/materials',
        claims: ['all'],
      },
      {
        text: 'Рецепты',
        path: '/recept',
        claims: ['all'],
      },
    ],
  },
  {
    text: 'Справочники',
    icon: <FaBook />,
    folder: true,
    claims: ['CanLookBookSection'],
    items: [
      {
        text: 'Транспорт',
        path: '/transport',
        claims: ['all'],
      },
      {
        text: 'Прицепы',
        path: '/trailers',
        claims: ['all'],
      },
      {
        text: 'Марки авто',
        path: '/transport-brand',
        claims: ['all'],
      },
      /* {
        text: 'География',
        path: '/template-salary',
        claims: ['all'],
      }, */
      {
        text: 'Ед. изм.',
        path: '/unit',
        claims: ['all'],
      },
      {
        text: 'Заводы',
        path: '/factory',
        claims: ['all'],
      },
    ],
  },
  {
    text: 'Движение материалов',
    icon: <GoGraph />,
    folder: true,
    claims: ['CanLookMovementNomenclatureSection'],
    items: [
      {
        text: 'Приход материалов',
        path: '/comming-materials',
        claims: ['CanLookComingMaterialSection'],
      },
      {
        text: 'Расход материалов',
        path: '/expense-materials',
        claims: ['CanLookConsumptionNomenclatureSection'],
      },
      {
        text: 'Расчет запчастей',
        path: '/comming-fare',
        claims: ['CanLookPassCalculationSection'],
      },
      {
        text: 'Сверка по карьерам',
        path: '/career-reconciliation',
        claims: ['CanLookCareerReportSection'],
      },
      {
        text: 'Начальные остатки',
        path: '/initial-balance',
        claims: ['CanLookAndEditStartMaterialRemains'],
      },
      {
        text: 'Остатки инерта',
        path: '/consumption',
        claims: ['CanLookMaterialRemains'],
      },
      {
        text: 'Перекидка',
        path: '/nomenclatureTransferList',
        claims: ['CanLookNomenclatureTransferSection'],
      },
      /* {
      text: 'Остатки на складах',
      path: '/remainder-materials',
    }, */
    ],
  },
  {
    text: 'Расчет з/п',
    icon: <GoGraph />,
    folder: true,
    claims: ['CanLookSalarySection'],
    items: [
      {
        text: 'Отчет по сменам',
        path: '/employee-report',
        claims: ['all'],
      },
      {
        text: 'Оплата тонаристам',
        path: '/salary-tonar',
        claims: ['CanLookSalaryTonarSection'],
      },
      {
        text: 'Оплата миксеристам',
        path: '/salary-mixers',
        claims: ['CanLookSalaryMixerSection'],
      },
      {
        text: 'Оплата окладникам',
        path: '/salary-employee',
        claims: ['CanLookSalaryFixedSection'],
      },
      {
        text: 'Оплата насосников',
        path: '/salary-pump',
        claims: ['CanLookSalaryMixerSection'],
      },
      {
        text: 'Настройка зарплаты окладников',
        path: '/employee-salary',
        claims: ['CanLookSalaryFixedConfigurationSection'],
      },
      {
        text: 'Настройка зарплаты насосников',
        path: '/pump-salary',
        claims: ['CanLookDriverMixerSalaryConfiguration'],
      },
      {
        text: 'График смен',
        path: '/employees-report-work',
        claims: ['CanSeeOperatingSchedule'],
      },
      {
        text: 'Повышенная ставка транспорта',
        path: '/TransportOverRateMixer',
        claims: ['CanLookTransportOverRateSection'],
      },
      /* {
        text: 'Повышенная ставка транспорта',
        path: '/TransportOverRate',
        claims: ['CanLookTransportOverRateSection'],
      }, */
    ],
  },
  {
    text: 'Касса',
    icon: <FaCashRegister />,
    folder: true,
    claims: ['CanLookCashboxesSection'],
    items: [
      {
        text: 'Статьи движения ДС',
        path: '/cash-list',
        claims: ['all'],
      },
      {
        text: 'Движения по кассе',
        path: '/cash-flow',
        claims: ['all'],
      },
      ...items.map((i) => ({
        text: i.name,
        path: `/cash-flow-list-detail/${i.id}`,
        claims: ['all'],
      })),
      {
        text: 'Удаленные документы',
        path: '/cash-flow-deleted-documents',
        claims: ['CanLookDeletedCashFlowDocuments'],
      },
    ],
  },
  {
    text: 'Администрирование',
    icon: <RiAdminFill />,
    folder: true,
    claims: ['CanSeeAdminSection'],
    items: [
      {
        text: 'Роли',
        path: '/role',
        claims: ['CanEditEmployees'],
      },
      {
        text: 'Сотрудники и их роли',
        path: '/accounts',
        claims: ['CanLookUserSection'],
      },
    ],
  },
  {
    text: 'Охрана',
    icon: <MdOutlineSecurity />,
    folder: true,
    claims: ['CanSeeSecuritySection'],
    items: [
      {
        text: 'Подтверждение отгрузок',
        path: '/security/confirm',
        claims: ['CanSeeCheckOutTimeSection'],
      },
    ],
  },
];
